import React from "react";
import { getImageURL, personFolder } from "../../../../../../../resources/api";
import styled from "styled-components";
import {IServerStatistics } from "../../../../../../../libs/redux";
import tw from "tailwind.macro";
import {getCheckAmountColor, getColor} from "resources/helpers/helper";
import {MainStructure, ContainerPreview, WrapInfoPreview, Line, WrapNumPreview} from "../../../../../../../resources/styles/components/cards";
import { formatMoney } from "utils/text";

interface StyledProps {
  colors: {
    cardColor: string;
    overallColor: string;
  };
}

const CardStyle = styled.div`
  ${tw`flex w-full border-solid rounded border-2 sm:border-2 lg:border-4`}
  border-color: ${(props: StyledProps) => props.colors.cardColor};
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  .overall {
    color: ${(props) => props.colors.overallColor};
  }
  .amount {
    font-weight: 800;
  }

  p {
    font-size: 2rem;
  }

  @media (max-width: 970px) {
    padding: 6px 0;
    p {
      font-size: 1rem;
    }
  }
  @media (max-width: 640px) {
    padding: 3px 0;
    p {
      font-size: 0.7rem;
    }
  }
`;

const CustomWrapInfoPreview = styled(WrapInfoPreview)`
  align-items: flex-start;
`;

const CustomContainerPreview = styled(ContainerPreview)`
    img {
        border-radius: 50%;
        height: 80px;
        width: 80px;
    }

    @media (max-width: 970px) {
        img {
            height: 50px;
            width: 50px;
        }
    }
    @media (max-width: 640px) {
        img {
            height: 35px;
            width: 35px;
        }
    }
`;

const ServersCard: React.FC<IServerStatistics> = ({
  id,
  rating,
  name,
  avgAmount,
  guests,
  amount,
}) => {

  const colors = {
    cardColor: getCheckAmountColor(avgAmount),
    overallColor: getColor(rating),
  };

  return (
    <MainStructure>
      <CardStyle colors={colors}>
        <ContainerPreview>
          <CustomContainerPreview width={"30%"}>
            <img src={getImageURL(personFolder, `${id}.png`)} alt=""/>
            <CustomWrapInfoPreview width={"50%"}>
              <p>{name ? name.split(' ')[0] : '-'}</p>
            </CustomWrapInfoPreview>
          </CustomContainerPreview>
          <WrapNumPreview width={"15%"}>
            <Line /> 
              <p>{guests ? guests : "-"}</p>
            <Line width={'0'}/>
          </WrapNumPreview>
          <WrapNumPreview width={"20%"}>
            <Line /> 
              <p className="amount">{avgAmount ? formatMoney(avgAmount) : "-"}</p>
            <Line width={'0'}/> 
          </WrapNumPreview>
          <WrapNumPreview width={"20%"}>
            <Line /> 
              <p className="amount">{amount ? formatMoney(amount) : "-"}</p>
            <Line width={'0'}/> 
          </WrapNumPreview>
          <WrapNumPreview width={"15%"}>
            <Line /> 
              <p  className="overall">{rating ? rating : "-"}</p>
            <Line width={'0'}/>
          </WrapNumPreview>
        </ContainerPreview>
      </CardStyle>
    </MainStructure>
  );
};

export default ServersCard;
